import { formatData } from "../common/FetchFilterData";
import FilterBase from "../common/FilterBase"
const url = "https://app.vantetider.se/spa/1.1/rest/filters/filterchoices/predictionfilter";

class predictionsFilter extends FilterBase {
    static get observedAttributes() {
        return super.observedAttributes.concat("servicetype");
    }
    constructor() {
        super();
        let firstDiv = "firstDiv";

        const selectorOptions = [
            {
                name: "buttonSelect",
                button: true,
                header: "Kontakttyp",
                events: [
                    {
                        name: "change",
                        callback: function (e) {
                            let filter = document.getElementsByTagName("prediction-filter")[0];
                            filter.setAttribute("servicetype", this.getSelected());
                        }
                    }
                ]
            },
            {
                name: "regionSelect",
                divName: firstDiv,
                events: [
                    {
                        name: "change",
                        callback: this.dispatchSubmitEvent.bind(
                            this,
                            "predictionFilterSubmit",
                            this.getSelectorValues.bind(this),
                            this.getSelectorTexts.bind(this))
                    }
                ]
            },
            {
                name: "serviceSelect",
                divName: firstDiv,
                events: [
                    {
                        name: "change",
                        callback: this.dispatchSubmitEvent.bind(
                            this,
                            "predictionFilterSubmit",
                            this.getSelectorValues.bind(this),
                            this.getSelectorTexts.bind(this))
                    }
                ]
            },
            {
                name: "ownerSelect",
                divName: firstDiv,
                data: ["Alla ägarformer", "Privat", "Offentlig"],
                events: [
                    {
                        name: "change",
                        callback: this.dispatchSubmitEvent.bind(
                            this,
                            "predictionFilterSubmit",
                            this.getSelectorValues.bind(this),
                            this.getSelectorTexts.bind(this))
                    }
                ]
            },
        ]
        this.addSelectors(selectorOptions);
        this.getData();
        this.addSearchRequestListener("predictionsSearchReq");
    }

    async getData() {
        try {
            const res = await formatData({}, url);

            res.region.unshift({
                name: "Alla regioner",
                value: -1
            })
            res.operationServices.unshift({
                name: "Välj åtgärd",
                value: -1
            })
            res.visitServices.unshift({
                name: "Välj åtgärd",
                value: -1
            })
            this.storedData = res;
            this.addDataToSelect("regionSelect", res.region);
            this.addDataToButtonSelect("buttonSelect", res.serviceTypes);
        } catch (error) {
            console.error(error);
        }
    }

    getSelectorValues() {
        return {
            regionIds: this.getSelectValue("regionSelect"),
            serviceId: this.getSelectValue("serviceSelect"),
            phase: this.getSelectValue("buttonSelect"),
            management: this.getSelectValue("ownerSelect")
        }
    }
    getSelectorTexts() {
        return {}
    }
    attributeChangedCallback(name, oldval, newval) {
        if (oldval !== newval) {
            if (name === "servicetype") {
                var data;
                switch (newval) {
                    case "0":
                        data = this.storedData.visitServices
                        break;
                    case "1":
                        data = this.storedData.operationServices
                        break;
                    default:
                        console.error("Unrecognized servicetype", newval, typeof newval)
                        break;
                }
                this.addDataToSelect("serviceSelect", data);
                this.addDataToSelect("ownerSelect", ["Alla ägarformer", "Privat", "Offentlig"]);

                let table = document.getElementsByTagName("prediction-table")[0];
                table.table.innerHTML = "";
            }
        }
    }

    set serviceType(x) {
        this.setAttribute("serviceType", x);
    }

    get serviceType() {
        return this.getAttribute("serviceType");
    }

}

if (!customElements.get("prediction-filter")) {
    FilterBase.define("prediction-filter", predictionsFilter)
}
